import { Injectable } from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import { AdminService, ApiService, AuthService, CalendarService, ConditionService, DialogService, FieldService, FormulaService, MetadataService, ModalService, SessionService, TranslatorService } from '..';
import { UscStoreService } from '../usc-store/usc-store.service';
import { User } from '../../models';

@Injectable()
export class UscStoreMobileService {

    metaDataSub: Subscription;
    getConsultantSalesQuotaAchievementsSub: Subscription;
    getConsultantSalesGoalAchievementsSub: Subscription;
    getTodaysConsultantSalesGoalAchievementsSub: Subscription;
    getStoreSalesQuotaAchievementsSub: Subscription;
    getStoreTodaysSalesQuotaAchievementsSub: Subscription;
    getAwardedUsersSub: Subscription;
    p2w_achievement_initialized:boolean = false;
    init_mobile_session: boolean = false;

    constructor(
        public metadataService: MetadataService,
        public sessionService: SessionService,
        public uscStoreService: UscStoreService,
        public authService: AuthService,
        public adminService: AdminService,
    ) { }

    initializeMobileSession(user:User) {
        if (!this.init_mobile_session) {
            this.init_mobile_session = true;
            this.uscStoreService.setPortalInitializationItem("loadMetadata", "initializing");
            // this.sessionService.log("Meta Data Loading:", new Date()); 
            this.metaDataSub = this.metadataService.loadMetadata().subscribe(
                data => { 
                    this.uscStoreService.setP2WInitializationItem("loadMetadata", "initialized");
                    this.sessionService.log("Meta Data Loaded", new Date());
                },
                err => { this.sessionService.log(err) }
            )

            if (!this.p2w_achievement_initialized && !this.uscStoreService.isP2WInitialized()) {
                this.initializeP2WAchievements(user);
            }
            
            this.uscStoreService.p2wReady.subscribe(ready => {
                if (ready) {
                    this.p2w_achievement_initialized = true;
                    if (!this.uscStoreService.isUSCellAgent()) this.uscStoreService.loadPreviousActionPlans();
                } 
            })
        }
    }
    
    initializeP2WAchievements(user:User, bReload: boolean = false) {
        this.uscStoreService.setP2WInitializationItem("getConsultantSalesQuotaAchievements", "initializing");
        this.getConsultantSalesQuotaAchievementsSub = this.uscStoreService.getConsultantSalesQuotaAchievements(bReload).subscribe(result => {
            this.uscStoreService.setP2WInitializationItem("getConsultantSalesQuotaAchievements", "initialized");
            this.sessionService.log('USC Mobile Consultant Sales Quota Achievements Loaded');
        })

        this.uscStoreService.setP2WInitializationItem("getConsultantSalesGoalAchievements", "initializing");
        this.getConsultantSalesGoalAchievementsSub = this.uscStoreService.getConsultantSalesGoalAchievements(bReload).subscribe(result => {
            this.uscStoreService.setP2WInitializationItem("getConsultantSalesGoalAchievements", "initialized");
            this.sessionService.log('USC Mobile Consultant Sales Goal Achievements Loaded');
        })

        this.uscStoreService.setP2WInitializationItem("getTodaysConsultantSalesGoalAchievements", "initializing");
        this.getTodaysConsultantSalesGoalAchievementsSub = this.uscStoreService.getTodaysConsultantSalesGoalAchievements(bReload).subscribe(result => {
            this.uscStoreService.setP2WInitializationItem("getTodaysConsultantSalesGoalAchievements", "initialized");
            this.sessionService.log("USC Mobile Today's Consultant Sales Goal Achievements Loaded");
        })

        this.uscStoreService.setP2WInitializationItem("getStoreSalesQuotaAchievements", "initializing");
        this.getStoreSalesQuotaAchievementsSub = this.uscStoreService.getStoreSalesQuotaAchievements(bReload).subscribe(result => {
            this.uscStoreService.setP2WInitializationItem("getStoreSalesQuotaAchievements", "initialized");
            this.sessionService.log('USC Mobile Store Sales Quota Achievements Loaded');
        })

        this.uscStoreService.setP2WInitializationItem("getStoreTodaysSalesQuotaAchievements", "initializing");
        this.getStoreTodaysSalesQuotaAchievementsSub = this.uscStoreService.getStoreTodaysSalesQuotaAchievements(bReload).subscribe(result => {
            this.uscStoreService.setP2WInitializationItem("getStoreTodaysSalesQuotaAchievements", "initialized");
            this.sessionService.log("USC Mobile Today's Store Sales Quota Achievements Loaded");
        })
            
        // For USC Agent, we need to load the user list first as it has a tighter dependency 
        if (this.uscStoreService.isUSCellAgent()) {
            this.uscStoreService.setP2WInitializationItem("loadAgencyTeamUsers", "initializing");
            this.sessionService.log("Users Loading:", new Date()); 
            this.uscStoreService.loadAgencyTeamUsers(user);
            this.adminService.allUserLoaded.subscribe(bLoaded => {
                if (bLoaded) {
                    this.sessionService.log("Users Loaded", new Date());
                    this.uscStoreService.setP2WInitializationItem("loadAgencyTeamUsers", "initialized");
                }
            })
        } else {
            this.uscStoreService.setP2WInitializationItem("getAwardedUsers", "initializing");
            this.getAwardedUsersSub = this.uscStoreService.getAwardedUsers().subscribe(result => {
                this.uscStoreService.setP2WInitializationItem("getAwardedUsers", "initialized");
                this.sessionService.log("Awarded Users Loaded");
            }) 
        }
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/services/usc-store-mobile/usc-store-mobile-service.ts